import { EinstellungenForm } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/Forms/EinstellungenForm/useEinstellungenForm';
import { createContext } from 'react';

export const EinstellungenFormContext = createContext<EinstellungenForm | null>(
  null,
);
